import { render, staticRenderFns } from "./Welfare.vue?vue&type=template&id=17c17299&scoped=true"
import script from "./Welfare.vue?vue&type=script&lang=js"
export * from "./Welfare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c17299",
  null
  
)

export default component.exports